/**
 * PayrollSettings - Page principale des paramètres de paie.
 *
 * 🚀 NOUVEAU: Utilise maintenant CountrySpecificForm pour router
 * vers le formulaire spécifique du pays détecté.
 */

import CountrySpecificForm from "../components/payroll/forms/CountrySpecificForm";

const PayrollSettings = () => {
  return (
    <div>
      {/* 🚀 NOUVEAU: Router vers le formulaire spécifique du pays */}
      <CountrySpecificForm formType="settings" />
    </div>
  );
};

export default PayrollSettings;